import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOwnBusinessProfile } from '../services/businessService';

// Async thunk to fetch the authenticated user's business profile
export const fetchOwnBusinessProfile = createAsyncThunk(
  'businessProfile/fetchOwnBusinessProfile',
  async (_, thunkAPI) => {
    try {
      const response = await getOwnBusinessProfile();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const businessProfileSlice = createSlice({
  name: 'businessProfile',
  initialState: {
    data: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    clearBusinessProfile: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOwnBusinessProfile.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchOwnBusinessProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchOwnBusinessProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearBusinessProfile } = businessProfileSlice.actions;
export default businessProfileSlice.reducer;